/** @type {string} */
const tooltipString = "tooltip";
export default tooltipString;
